import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_tasks_entitiesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectIds?: number[], cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], minCreationDate?: string, minProjectId?: number, billingCodeIds?: number[] }): 
  Promise<{ result: { TaskCount?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, Project?: { LookupCode?: string }, Shipment?: { LookupCode?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectIds?: number[], cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], minCreationDate?: string, minProjectId?: number, billingCodeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TaskCount?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, Project?: { LookupCode?: string }, Shipment?: { LookupCode?: string }, Warehouse?: { Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectIds?: number[], cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], minCreationDate?: string, minProjectId?: number, billingCodeIds?: number[], $keys: { ProjectId?: number, ShipmentId?: number, WarehouseId?: number, Project?: { LookupCode?: string }, Shipment?: { LookupCode?: string }, Warehouse?: { Name?: string } }[] }): 
  Promise<{ result: { TaskCount?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, Project?: { LookupCode?: string }, Shipment?: { LookupCode?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectIds?: number[], cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], minCreationDate?: string, minProjectId?: number, billingCodeIds?: number[]    }) {
      return false;
    }
}
